module.exports = __webpack_public_path__ + "static/media/layersWhite.fb46f24e.png";